<script lang="ts">
  import { getModalStore, RadioGroup, RadioItem } from '@skeletonlabs/skeleton';
  import { clientContractConfigStore } from '$lib/stores/clientContractConfigStore';
  import { onMount } from 'svelte';

  const modalStore = getModalStore();
  const onSave = $modalStore[0].meta.onSave;
  export let parent: any;

  let clientContractSummary: ClientContractSummary;
  let loading = true;
  let error = '';
  let fileInput: HTMLInputElement;

  onMount(async () => {
    const Id = $modalStore[0].meta.Id || 0;
    await fetchSummary(Id);
    loading = false;
  });

  async function fetchSummary(Id: number) {
    try {
      clientContractSummary = (await clientContractConfigStore.getContractDetails(Id)) as ClientContractSummary;
    } catch (err) {
      error = err instanceof Error ? err.message : 'Error fetching Client Contract';
    }
  }

  async function onFormSubmit() {
    try {
      const updatedContract = await clientContractConfigStore.updateContract(clientContractSummary);
      if (updatedContract.id) {
        onSave();
        modalStore.close();
      } else {
        error = 'Failed to update client contract';
      }
    } catch (err) {
      error = err instanceof Error ? err.message : 'Error updating client contract';
    }
  }
</script>

<div class="card w-modal flex max-h-[80vh] flex-col shadow-xl">
  <header class="p-4 text-2xl font-bold">Edit Client Contract</header>
  <div class="flex-grow overflow-y-auto p-4">
    {#if loading}
      <p>Loading...</p>
    {:else if clientContractSummary}
      {#if error}
        <div class="card mb-4 bg-error-500 p-4 text-white">
          <p>{error}</p>
        </div>
      {/if}
      <form class="space-y-4 border border-surface-500 p-4 rounded-container-token">
        <label class="label">
          <span>Client ID</span>
          <input class="input" type="text" value={clientContractSummary.clientId} readonly />
        </label>
        <label class="label">
          <span>Client Name</span>
          <input class="input" type="text" value={clientContractSummary.clientName} readonly />
        </label>
        <label class="label">
          <span>Contract Start Date</span>
          <input class="input" type="text" value={new Date(clientContractSummary.contractStartDate).toLocaleDateString('en-AU')} readonly />
        </label>
        <label class="label">
          <span>Monthly Fee</span>
          <input class="input" type="number" inputmode="decimal" bind:value={clientContractSummary.monthlyFee} />
        </label>
        <label class="label">
          <span>Included Scans</span>
          <input class="input" type="number" bind:value={clientContractSummary.includedScans} />
        </label>
        <label class="label">
          <span>Additional Scan Fee</span>
          <input class="input" type="number" inputmode="decimal" bind:value={clientContractSummary.additionalScanFee} />
        </label>



      </form>
    {/if}
  </div>
  <footer class="modal-footer {parent.regionFooter} p-4">
    <button class="btn {parent.buttonNeutral}" on:click={parent.onClose}>{parent.buttonTextCancel}</button>
    <button class="btn {parent.buttonPositive}" on:click={onFormSubmit}>Save Changes</button>
  </footer>
</div>

<style lang="postcss">
  .label:not(:has(input[type='checkbox'])) > span {
    text-wrap: nowrap;
    @apply text-primary-400;
  }

  .input {
    @apply border border-secondary-400;
  }
</style>
